import { computed, ref } from 'vue';
import {
  setAdditiveGroup,
  updateAdditiveGroup,
  dndAdditiveGroups,
  deleteAdditiveGroup,
  setNewAdditive,
  axDeleteAdditive,
  dndAdditives,
  axUpdateAdditive,
  axGetAdditives,
} from '@/services/additives.axios.service';
import axiosInstance from './axios.service';

export const selectedPoint = ref(null);
export const currentAccordionItem = ref();
export const inputGroup = ref('');
export const isModalOpen = ref(false);

export const checkCurrentItem = computed(() => (indx) => currentAccordionItem.value === indx);

export function resetAdditivesServiceState() {
  selectedPoint.value = null;
  currentAccordionItem.value = null;
  inputGroup.value = '';
  isModalOpen.value = false;
}

/* ==_addNewGroup_== */
export async function addNewGroup(pointId) {
  if (inputGroup.value) {
    const newGroup = {
      pointId,
      name: inputGroup.value,
      isVisible: true,
    };
    try {
      const res = await setAdditiveGroup(newGroup);
      console.log('addNewGroup:res', res);
      isModalOpen.value = false;
      inputGroup.value = '';
      res.type = 'added';
      return res;
    } catch (error) {
      console.error(error);
    }
  }
}

export async function updateGroup(currentGroupId, isVisible) {
  if (inputGroup.value) {
    const updGroup = {
      id: currentGroupId,
      name: inputGroup.value,
    };
    try {
      const res = await updateAdditiveGroup(updGroup);
      console.log('updGroup:res', res);
      isModalOpen.value = false;
      inputGroup.value = '';
      res.type = 'updated';
      return res;
    } catch (error) {
      console.error(error);
    }
  } else {
    try {
      console.log('isVisible', isVisible);
      console.log('currentGroupId', currentGroupId);

      const res = await updateAdditiveGroup({
        id: currentGroupId,
        isVisible,
      });
      res.type = 'changeVisible';
      return res;
    } catch (error) {
      console.error(error);
    }
  }
}

export async function shiftGroups(dataForUpdate) {
  try {
    console.log('======>>>>>', dataForUpdate);

    const res = await dndAdditiveGroups(dataForUpdate);
    res.type = 'dndGroups';
    return res;
  } catch (error) {
    console.error(error);
  }
}

// dndAdditive
export async function shiftAdditives(dataForUpdate) {
  try {
    console.log('======>>>>>', dataForUpdate);

    const res = await dndAdditives(dataForUpdate);
    res.type = 'dndAdditives';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function deleteGroup(dataForDelete) {
  try {
    const res = await deleteAdditiveGroup(dataForDelete);
    res.type = 'groupDelete';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function deleteAdditive(dataForDelete) {
  try {
    const res = await axDeleteAdditive(dataForDelete);
    res.type = 'additiveDelete';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function addNewAdditive(additive) {
  try {
    const res = await setNewAdditive(additive);
    console.log('addNewAdditive:res', res);
    isModalOpen.value = false;
    inputGroup.value = '';
    res.type = 'addAdditive';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function updateAdditiveVisibility(additive) {
  const objForUpdate = {
    id: additive.id,
    isVisible: additive.isVisible,
  };
  try {
    const res = await axUpdateAdditive(objForUpdate);
    isModalOpen.value = false;
    inputGroup.value = '';
    res.type = 'updateAdditive';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function updateAdditiveAvailability(additive) {
  const objForUpdate = {
    id: additive.id,
    isAvailable: additive.isAvailable,
  };
  try {
    const res = await axUpdateAdditive(objForUpdate);
    isModalOpen.value = false;
    inputGroup.value = '';
    res.type = 'updateAdditiveAvailability';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function updateOneAdditive(additive) {
  try {
    const res = await axUpdateAdditive(additive);
    res.type = 'updateAdditive';
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function getAdditivesArr(objAdditive) {
  try {
    const res = await axGetAdditives(objAdditive);
    res.type = 'getAdditives';
    return res;
  } catch (error) {
    console.error(error);
  }
}
